import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AppComponent } from '../../app.component';
import { NgForm } from '@angular/forms';
import { SharedDataService } from '../../shared/services/shared-data.service';
import { TranslateService } from '@ngx-translate/core';
import { UserInfo } from '../../settings/users/userdetails/userDetails-model';
import * as api from '../../shared/api/apihandler';
import { UserService } from 'app/shared/services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  @ViewChild('f')
  signupForm: NgForm;
  loading = true;
  vat: string = '';
  user: string = null;
  name: string = null;
  address: string = null;
  zipcode: string = null;
  city: string = null;
  phone: string = null;
  email: string = null;
  voucher: string = null;
  comment: string = null;
  language: string = '6A1383E8-BCC8-45E3-90EA-171C92C9BF2B';
  jubloId: number = null;
  orgId: number = null;
  personId: number = null;
  gdpr = true;
  iso;
  country: string = 'da-DK';
  currency;
  closeResult: string;
  body: any;
  appLogin = false;
  outbox = false;
  loginToCase = false;
  caseId;
  userInfo;
  signIn = true;
  signUp = false;
  creatingCompany = false;
  signUpComplete = false;
  countDown;
  login;
  url;
  error;
  redirectToDashboard = false;
  moduleName;
  public show: boolean = true;

  constructor(public authService: AuthService, private route: ActivatedRoute, public router: Router, private http: HttpClient, private app: AppComponent, private sharedData: SharedDataService, translate: TranslateService, private globalSrv: UserService) {
    if (!!this.route.snapshot.queryParams && !!this.route.snapshot.queryParams.module) {
      this.moduleName = this.route.snapshot.queryParams.module;
    }
    if (!this.router.url.includes('OS')) {
      this.loading = false;
    }
    if (!!localStorage.getItem('bearer') && !!this.route.snapshot.paramMap.get('token') && localStorage.getItem('bearer') != this.route.snapshot.paramMap.get('token')) {
      localStorage.clear();
    }
    if (this.router.url.indexOf('/OS/Outbox') > -1) {
      console.log('outbox');
      const headers = new HttpHeaders().set("Content-Type", "application/json");
      this.http.get(api.jubloApi + 'api/Website/Login/GetGuards/Using/Token?token=' + this.route.snapshot.paramMap.get('token'),
        { headers }).subscribe(
          (val: Login) => {
            this.login = val;
            this.outbox = true;
            this.sharedData.getCompanyUserFilter();
            this.setupLogin();
          },
          response => {
            this.error = true;
            this.loading = false;
          },
          () => {
            this.show = false;
            this.loading = false;
          }
        );
    } else if (this.router.url.includes('/LoginWithCase/')) {
      const headers = new HttpHeaders().set("Content-Type", "application/json");
      this.http.get(api.jubloApi + 'api/Website/Login/GetGuards/Using/Token?token=' + this.route.snapshot.paramMap.get('token'),
        { headers }).subscribe(
          (val: Login) => {
            this.loginToCase = true;
            this.login = val;
            this.caseId = this.route.snapshot.paramMap.get('caseId');
            this.setupLogin();
        },
        response => {
          this.error = true;
          this.loading = false;
        },
        () => {
          this.show = false;
          this.loading = false;
        }
      );
    }
    else if (this.router.url.indexOf('/OS/') > -1) {
      const headers = new HttpHeaders().set("Content-Type", "application/json");
      this.http.get(api.jubloApi + 'api/Website/Login/GetGuards/Using/Token?token=' + this.route.snapshot.paramMap.get('token'),
        { headers }).subscribe(
          (val: Login) => {
            this.login = val;
            this.setupLogin();
        },
        response => {
          this.error = true;
          this.loading = false;
        },
        () => {
          this.show = false;
          this.loading = false;
        }
      );
    }
    else if (this.router.url.indexOf('/accessToken/') > -1) {
      const headers = new HttpHeaders().set("Content-Type", "application/json");
      this.http.get(api.jubloApi + 'api/Website/Login/GetModuleGuards/' + this.route.snapshot.paramMap.get('token'),
        { headers }).subscribe(
          (val: Login) => {
            this.login = val;
            this.setupLogin();
          },
          response => {
            this.error = true;
            this.loading = false;
          },
          () => {
            this.show = false;
            this.loading = false;
          }
        );
    }
    else if (this.router.url.indexOf('/Cases/') > -1) {
      const headers = new HttpHeaders().set("Content-Type", "application/json");
      this.http.get(api.jubloApi + 'api/Website/Login/GetGuards/Using/Token?token=' + this.route.snapshot.paramMap.get('token'),
        { headers }).subscribe(
          (val: Login) => {
            this.login = val;
            this.setupLogin();
          },
          response => {
            this.error = true;
            this.loading = false;
          },
          () => {
            this.show = false;
            this.loading = false;
          }
        );
    }
    else if (this.router.url.indexOf('/SSO/') > -1) {
      const headers = new HttpHeaders().set("Content-Type", "application/json");
      this.http.get(api.jubloApi + 'api/Website/Login/GetGuards/Using/SSO/' + this.route.snapshot.paramMap.get('token'),
        { headers }).subscribe(
          (val: Login) => {
            this.login = val;
            this.setupLogin();
          },
          response => {
            this.error = true;
            this.loading = false;
          },
          () => {
            this.show = false;
            this.loading = false;
          }
        );
    }
    else if (this.route.snapshot.paramMap.get('token') != null) {
      const headers = new HttpHeaders().set("Content-Type", "application/json");
      this.http.get(api.jubloApi + 'api/Website/Login/GetGuards/Using/Token?token=' + this.route.snapshot.paramMap.get('token'),
        { headers }).subscribe(
          (val: Login) => {
            this.login = val;
            this.setupLogin();
          },
          response => {
            this.error = true;
            this.loading = false;
          },
          () => {
            this.show = false;
            this.loading = false;
          }
        );
    }
    else if (this.router.url.indexOf('/Offer/') > -1) {
      const headers = new HttpHeaders().set("Content-Type", "application/json");
      this.http.get(api.jubloApi + 'api/Website/Login/GetModuleGuards/' + this.route.snapshot.paramMap.get('accessToken'),
        { headers }).subscribe(
        (val: Login) => {
          this.login = val;
          this.setupLogin();
        },
        response => {
          this.error = true;
          this.loading = false;
        },
        () => {
          this.show = false;
          this.loading = false;
        }
      );
    }
  }

  originCheck(id: string) {
    if (!!id) {
      switch (id) {
        case '5c10ee31-e2a4-4f19-a15d-9aeba265b58f':
          localStorage.setItem('osHub', 'true');
          break;
      
        default:
          localStorage.setItem('osHub', 'false');
          break;
      }
    }
  }

  // kplogin med accessToken

  getGdpr() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<any>(api.jubloApi + 'api/WebSite/Company/User/GetGdpr', { headers }).subscribe({
      next: (data) => { this.gdpr = data; },
      error: err => console.error(err),
      complete: () => {
        localStorage.setItem('Gdpr', JSON.stringify(this.gdpr));
        if (this.gdpr) {
          this.login.guard.push({ 'name': 'GDPR' });
          localStorage.setItem('guards', JSON.stringify(this.login.guard));
          setTimeout(() => {
            if (localStorage.getItem('testAccess') == 'true' && !location.hostname.match('applicationv2-kundetest.azurewebsites.net') && !location.hostname.match('localhost')) {
              window.location.href = 'https://applicationv2-kundetest.azurewebsites.net/login/' + localStorage.getItem('bearer');
            } else if (!!sessionStorage.getItem('redirectUrl')) {
              this.router.navigate([sessionStorage.getItem('redirectUrl')]).then(() => { window.location.reload(); });
              sessionStorage.removeItem('redirectUrl');
            } else if (this.appLogin) {
              this.router.navigate(['Cases']).then(() => { window.location.reload(); });
            } else if (this.loginToCase && !!this.caseId) {
              this.router.navigate(['Details/' + this.caseId]).then(() => { window.location.reload(); });
            } else if (this.route.snapshot.paramMap.get('offerId') != null) {
              this.router.navigate(['Details/' + this.route.snapshot.paramMap.get('offerId')], { queryParams: { mode: "design" } }).then(() => { window.location.reload(); });
            } else if (this.outbox && !!this.login.guard.find(x => x.name == 'TransferAccess')) {
              this.router.navigate(['Outbox']).then(() => { window.location.reload(); });
            } else if (!!this.login.guard.find(x => x.name == 'SettingsAccess')) {
              this.router.navigate(['Dashboard']).then(() => { window.location.reload(); });
            } else {
              this.router.navigate(['Cases']).then(() => { window.location.reload(); });
            }
          },
          2000);
        }
        else {
          this.router.navigate(['Gdpr']).then(() => { window.location.reload(); });
        }
      }
    });
  }

  async Login(username: string, password: string) {
    this.loading = true;
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    await this.http.post(api.jubloApi + 'api/Website/Login',
      { "email": username, "password": password },
      { headers }).subscribe(
        (val: Login) => {
          this.login = val;
          this.sharedData.getCompanyUserFilter();
          this.setupLogin();
        },
        response => {
          console.log("POST call error", response);
          this.error = true;
          this.loading = false;
        },
        () => {
          this.show = false;
          this.loading = false;
        }
      );
  }

  async setupLogin() {
    this.originCheck(this.login.originId);
    this.authService.checkIfPropbinder(this.login.bearer, null);
    let g = this.login.guard;
    if (g.filter(x => x.name == 'SettingsAccess').length > 0) { this.redirectToDashboard = true };

    // Conditional Access
    if (g.find(x => x.name == 'SettingsAccess') && !g.find(x => x.name == 'PartnerAccess')) { g.push({ 'name': 'PartnerAccess' }) };
    if (g.find(x => x.name == 'SettingsAccess') && !g.find(x => x.name == 'TransferAccess')) { g.push({ 'name': 'TransferAccess' }) };
    if (g.find(x => x.name == 'SettingsAccess') && !g.find(x => x.name == 'PackageAccess')) { g.push({ 'name': 'PackageAccess' }) };
    if (g.find(x => x.name == 'SettingsAccess') && !g.find(x => x.name == 'Offer')) { g.push({ 'name': 'PartnerOfferAccess' }) };

    // Set Language
    localStorage.setItem('language', this.login.language);
    this.app.changeLang(localStorage.getItem('language'));
    this.authService.login(this.login.bearer);
    localStorage.setItem('klarpris', this.login.klarpris);
    localStorage.setItem('integration', this.login.integrationId);
    localStorage.setItem('testAccess', this.login.testAccess);

    if (!!this.moduleName) {
      localStorage.setItem('moduleName', this.moduleName);
    }

    // Get Base Info
    this.getUserPermissions(g);
    this.sharedData.getCompanyInformation();
    this.sharedData.getUserInformation();
    this.sharedData.getCompanyUserFilter();
  }

  getUserPermissions(guards: any) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<any>(api.jubloApi + 'api/WebSite/Company/User/' + localStorage.getItem('bearer') + '/Permission', { headers }).subscribe({
      next: (data) => {
        // Store Guards
        if (!!data && data.find(x => x.name == 'RatingAccess' && !x.isSet) && data.find(x => x.name == 'AllCasesAccess' && !x.isSet)) { console.log('no rating'); guards = guards.filter(x => x.name != 'Rating'); }
        if (!!data && !data.find(x => x.name == 'OfferAccess')) { console.log('no offer'); guards = guards.filter(x => x.name != 'Offer'); }
        this.login.guard = guards;
        localStorage.setItem('guards', JSON.stringify(guards));
      },
      error: err => console.error(err),
      complete: () => {
        this.getUserInformation();
        this.getGdpr();
      }
    });
  }

  async getUserInformation() {
    let isLoggedIn;
    this.authService.isLoggedIn().subscribe({
      next: (data) => isLoggedIn = data,
      complete: () => {
        if (isLoggedIn) {
          const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
          this.http.get<UserInfo>(api.jubloApi + 'api/WebSite/Company/User/UserInfo', { headers }).subscribe({
            next: (data) => {
              this.userInfo = data;
              localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
            }
          });
        }
      }
    });
  }

  countdomTimer() {
    setTimeout(() => {
      if (this.countDown >= 0) {
        this.countDown = this.countDown - 1
        this.countdomTimer();
      }
    }, 1000);
  }

  createInPipeDrive() {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.http.post(api.jubloApi + 'api/Pipedrive/Create',
      {
        "name": this.name,
        "address": this.address,
        "e60f122b3aca703a0691afd05aa9c8b7c77ba718": this.vat,
        "fe17522d2129db82d1739002bb85a12be848eddb": this.jubloId,
        "dc827ac18971f49126bac44452db32db4934993b": "OS3",
        "6dde5dfacb8244209b25415eb820a20703f0adf2": this.email
      },
      { headers }
    ).subscribe(
      async (val: any) => {
        this.orgId = await val;
      },
      response => {
        console.log("POST call error", response);
      },
      () => {
        this.addPersonToPipeDrive();
      }
    );
  }

  addPersonToPipeDrive() {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.http.post(api.jubloApi + 'api/Pipedrive/Contact',
      {
        "name": this.user,
        "org_id": this.orgId,
        "email": this.email,
        "phone": this.phone
      },
      { headers }
    ).subscribe(
      async (val: any) => {
        this.personId = await val;
      },
      response => {
        console.log("POST call error", response);
      },
      () => {
        this.addDealToPipeDrive();
      }
    );
  }

  addDealToPipeDrive() {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.http.post(api.jubloApi + 'api/Pipedrive/Deal/' + this.vat + "/" + this.name + "/" + this.jubloId,
      {
        "title": "string",
        "currency": "DKK",
        "user_id": 698028,
        "person_id": this.personId,
        "org_id": this.orgId,
        "status": "OPEN",
      }
      ,
      { headers }
    ).subscribe(
      val => { },
      response => {
        console.log("POST call error", response);
      },
      () => {
        this.addToRecurly();
      }
    );
  }

  addToRecurly() {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    switch (this.language) {
      case "6A1383E8-BCC8-45E3-90EA-171C92C9BF2B":
        {
          this.iso = "da";
          this.country = "DK";
          this.currency = "DKK";
          break;
        }
      case "43643161-A4D5-427D-9FE5-2232179E64B5":
        {
          this.iso = "en";
          this.country = "GB";
          this.currency = "GBP";
          break;
        }
      case "1EBD2823-A7FF-4162-80F3-4B5288AC6F89":
        {
          this.iso = "sv";
          this.country = "SE";
          this.currency = "SEK";
          break;
        }
      case "D41E7508-EFC8-4814-8619-78FD07F62EF6":
        {
          this.iso = "no";
          this.country = "NO";
          this.currency = "NOK";
          break;
        }
      case "BCBAEA8E-0692-47C1-9194-E9850F1A3312":
        {
          this.iso = "de";
          this.country = "DE";
          this.currency = "EUR";
          break;
        }
      default:
        {
          break;
        }
    }

    this.http.post(api.jubloApi + 'api/Recurly',
      {
        "account_code": this.jubloId.toString(),
        "username": this.user,
        "email": this.email,
        "first_name": this.user,
        "last_name": " ",
        "company_name": this.name,
        "vat_number": this.vat,
        "tax_exempt": true,
        "address": {
          "address1": this.address,
          "city": this.city,
          "state": " ",
          "zip": this.zipcode,
          "country": this.country,
          "phone": this.phone
        },
        "shipping_addresses": {
          "shipping_address": {
            "address1": this.address,
            "city": this.city,
            "state": " ",
            "zip": this.zipcode,
            "country": this.country,
            "phone": this.phone
          }
        },
        "accept_language": this.iso

      }
      ,
      { headers }
    ).subscribe(
      val => { },
      response => {
        console.log("POST call error", response);
      },
      () => {
        this.addToEconomic();

      }
    );
  }

  addToEconomic() {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.http.post(api.jubloApi + 'api/Website/EconomicCustomer',
      {
        "address": this.address,
        "corporateIdentificationNumber": this.vat,
        "city": this.city,
        "country": this.country,
        "currency": this.currency,
        "customerGroup": {
          "customerGroupNumber": 1
        },
        "customerNumber": this.jubloId,
        "email": this.email,
        "vatZone": {
          "vatZoneNumber": 0
        },
        "name": this.name,
        "paymentTerms": {
          "paymentTermsNumber": 0
        },
        "zip": this.zipcode,
        "vatNumber": null,
        "ean": {
          "ean": 0
        },
        "telephoneAndFaxNumber": this.phone
      }
      ,
      { headers }
    ).subscribe(
      val => { },
      response => {
        console.log("POST call error", response);
      },
      () => { }
    );
  }
}

export class Guard {
  public name: string;
}

export class Login {
  bearer: string;
  companyId: string;
  guard: Array<Guard>;
  language: string;
  name: string;
  integrationId: string;
  testAccess: boolean;
  originId: string;
}

